<div class="notification-item cursor-pointer" [class.notification-item-non-clickable]="!clickable" (click)="handleClick($event)">
  <div class="notification-item-content">
    <!-- Icon -->
    <div>
      <svg-icon [src]="getIconPath()" [svgClass]="getIconClasses()"></svg-icon>
    </div>

    <!-- Content -->
    <div class="notification-item-text flex-1 min-w-0">
      <h4 class="text-subheading-medium text-headingText">{{ title }}</h4>
      <div class="text-body-large text-bodyText" [innerHTML]="message"></div>
      
      <!-- Optional Action Button -->
      @if (actionButton) {
      <app-button 
        [label]="actionButton.label" 
        variant="secondary" 
        size="small"
        (onClick)="handleActionClick($event)" />
      }
    </div>

    <!-- Dismiss Button -->
    @if (showDismiss) {
    <button 
    class="flex items-center justify-center cursor-pointer"
      type="button" 
      (click)="handleDismiss($event)"
      aria-label="Dismiss notification">
      <svg-icon src="/icons/cross.svg" svgClass="w-4 h-4 text-notificationIconClose"></svg-icon>
    </button>
    }
  </div>
</div>
